import {atom} from "jotai";

export const SelectedConversationAudioPlayer = atom(null);
export const SelectedMessageAudioPlayer = atom(null);
